// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1llrk","input":"styles_input__3YMxg"};